import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { getBookmarksForItems } from '../../common/actions/user/bookmark'
import { IRootState } from '../../common/reducers'
import { IItem } from '../../typings/searchResults'
import ItemsBookmarksLoader from '../components/itemsBookmarksLoader'

interface IOwnProps {
  items: IItem[]
  children: React.ReactNode
}

interface IStateProps {
  userHasLoadAttempt: boolean
}

interface IDispatchProps {
  getBookmarksForItems: (itemIds: number[]) => Promise<any>
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { hasLoadAttempt } = state.user

  return {
    userHasLoadAttempt: hasLoadAttempt
  }
}

const mapDispatchToProps = (dispatch: Dispatch<IRootState>): IDispatchProps => {
  return {
    getBookmarksForItems: (itemIds: number[]) =>
      dispatch(getBookmarksForItems(itemIds))
  }
}

export type Props = IOwnProps & IStateProps & IDispatchProps

const ItemsBookmarksLoaderContainer = connect<
  IStateProps,
  IDispatchProps,
  IOwnProps,
  IRootState
>(mapStateToProps, mapDispatchToProps)(ItemsBookmarksLoader)

export default ItemsBookmarksLoaderContainer
